import Swiper, { Pagination, Autoplay } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-product-info-carousel]',
};

const classes = {
  swiperPagination: '.swiper-pagination',
};

class ProductInfoCarousel extends HTMLElement {
  constructor() {
    super();

    this.carouselWrappers = document.querySelectorAll(
      selectors.carouselWrapper
    );

    // Init the carousel on load.
    this.initCarousel();
  }

  initCarousel() {
    this.infoCarousel = new Swiper(selectors.carouselWrapper, {
      modules: [Pagination, Autoplay],
      loop: true,
      slidesPerView: 1,
      watchOverflow: true,
      freeMode: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: classes.swiperPagination,
        clickable: true,
      },
    });
  }
}

customElements.define('product-info-carousel', ProductInfoCarousel);
